export default __webpack_public_path__ + "static/media/tech-camps-at-school-location.b92e7c6c.png";